import { farasod } from "./api"

const endpoint = "/branch"

export const getBranch = async (branchId) => {
  const response = await farasod.get(`${endpoint}/${branchId}`)

  return response.data
}

export const getBranches = async () => {
  const response = await farasod.get(`${endpoint}`)

  return response.data
}

export const createBranch = async (data) => {
  const response = await farasod.post(`${endpoint}`, data)

  return response.data
}

export const editBranch = async (branchId, data) => {
  const response = await farasod.patch(`${endpoint}/${branchId}`, data)

  return response.data
}

export const deleteBranch = async (branchId) => {
  const response = await farasod.delete(`${endpoint}/${branchId}`)

  return response.data
}

export const getBranchPaymentSecrets = async (branchId) => {
  const response = await farasod.get(`${endpoint}/payment-secrets/${branchId}`)

  return response.data
}

export const changeBranchPaymentSecrets = async (branchId, data) => {
  const response = await farasod.patch(`${endpoint}/payment-secrets/${branchId}`, data)

  return response.data
}